import React from 'react'

import AdminNavbar from '../components/Navbar/AdminNavbar'
import AdminCourse from '../components/Admin/AdminCourse'

const AdminCoursesPage = () => {
  return (
    <>
    <AdminNavbar/>
    <AdminCourse/>
    </>
  )
}

export default AdminCoursesPage